import React from "react"
import classnames from "classnames"
import styles from "./FeatureFocusBlock.less"
import gtmHandler from "AtomicUtils/gtmHandler"
import { VideoPlayer } from "AtomicContainers"
import componentParser from "AtomicUtils/componentParser"
import {
  H5,
  Content,
  ArrowRightIcon,
  ArrowLeftIcon,
} from "AtomicComponents"
import debounce from 'AtomicUtils/debounce'
import checkVisible from 'AtomicUtils/checkVisible'
import { WINDOW } from "AtomicUtils/environment"

class FeatureFocusBlock extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      activeIndex: 0,
      boxInPage: false,
      visible: false,
      windowWidth: undefined,
    }
  }

  componentDidMount(){
    setTimeout(()=>{
      this._showOrHide()
      this._updateDimensions()
    },100)

    WINDOW.addEventListener("resize", debounce(this._updateDimensions, 250));
    WINDOW.addEventListener("scroll", debounce(this._showOrHide, 250), {
      passive: true
    })
  }

  componentWillUnmount() {
    WINDOW.removeEventListener("resize", debounce(this._updateDimensions, 250));
    WINDOW.removeEventListener("scroll", debounce(this._showOrHide,250), {
      passive: true
   });
  }

  _showOrHide = () => {
    const { frames } = this.props
    const { activeIndex, visible } = this.state
    if (this.video){
      if (checkVisible(this.video)){
        if (!visible){
          this.setState({
            visible: true
          }, () => {
            if (this.video && this.video.currentTime != 0){
              this.video.currentTime = frames[activeIndex].props.start
            }
            this.video.play()
          })
        }
      }else {
        if (visible){
          if (this.video && this.video.currentTime != 0){
            this.video.currentTime = frames[activeIndex].props.start
          }
          this.video.pause()

          this.setState({
            visible: false,
            boxInPage: false
          })
        }
      }
    }
  }

  _updateDimensions = () => {
    this.setState({
      windowWidth: WINDOW && WINDOW.innerWidth
    })
  }

  _handleClickNext = () => {
    const { activeIndex } = this.state
    const { frames } = this.props
    if (activeIndex !== frames.length - 1){
      this._playVideoOnNewTime(activeIndex + 1, true)
    } else {
      this._playVideoOnNewTime(0)
    }
    gtmHandler({
      pageCategory: "Feature focus",
      pageAction: `Clicked chevron - "NEXT"`
    })
  }

  _handleClickPrevious = () => {
    const { activeIndex } = this.state
    if (activeIndex !== 0) {
      this._playVideoOnNewTime(activeIndex - 1)
      gtmHandler({
        pageCategory: "Feature focus",
        pageAction: `Clicked chevron - "PREVIOUS"`
      })
    }
  }

  _playVideoOnNewTime = (newActiveIndex = 0, justContinue=false) => {
    const { frames } = this.props
    if ( this.video ){
      if (frames[newActiveIndex] && frames[newActiveIndex].props) {
        this.setState({
          boxInPage: false
        }, () => {
          setTimeout(() => {
            this.setState({
              activeIndex: newActiveIndex
            }, () => {
              if (!justContinue){
                this.video.currentTime = frames[newActiveIndex].props.start
              }
              this.video.play()
            })
          }, 1000);
        })
      }
    }else {
      setTimeout(() => {
        this._playVideoOnNewTime(newActiveIndex)
      }, 250);
    }
  }

  _onTimeUpdate = () => {
    // we need to pause video before reaching the next frame start time
    const { frames } = this.props
    const { activeIndex } = this.state
    if (this.video){
      if (activeIndex !== frames.length - 1) {
        if (this.video.currentTime > frames[activeIndex+1].props.start){
          this.video.pause()
          this.setState({
            boxInPage: true
          })
        }
      }
    }
  }

  _handleOnEnded = () => {
    this.setState({
      boxInPage: true
    })
  }

  render() {

    const {
      video,
      frames = []
    } = this.props

    const {
      activeIndex,
      fadeOut,
      windowWidth,
      boxInPage
    } = this.state


    if ( video === "" || !video ) return (<div> Video is not defined </div>)

    let CTA = frames[activeIndex].props.cta;
    let theme = 'dark';
    if (windowWidth >= 1200){
      theme = 'dark'
      CTA.props.styleName = 'whiteOutlined'
    }else if (windowWidth < 1200){
      theme = 'light'
      CTA.props.styleName = 'blackOutlined'
    }

    return (
      <div
        className={classnames({
          [styles.FeatureFocusBlock]: true
        })}>
        <VideoPlayer
          getRef={c => this.video = c}
          src={video}
          loop={false}
          autoPlay={false}
          onEnded={this._handleOnEnded}
          onTimeUpdate={this._onTimeUpdate}
        />
        <div className={classnames({
          [styles.FeatureFocusContentBox]: true,
          [styles.FeatureFocusContentBoxVisible]: boxInPage
        })}>
          <div className={classnames({
            [styles.FeatureFocusContentBoxInside]: true,
          })}>
            <div>
              {frames.length > 1 &&
                <div className={classnames({
                  [styles.ArrowsBoxContainer]: true
                })}>
                  <button
                    onClick={this._handleClickPrevious}
                    className={classnames({
                      [styles.ArrowsBox]: true
                    })}>
                    <ArrowLeftIcon style={{
                      width: '15px',
                      hegiht: '15px'
                    }} />
                  </button>
                  <div className={classnames({
                    [styles.Numbers]: true
                  })}>
                    <span className={classnames({
                      [styles.SingleNumber]: true,
                      [styles.ActiveNumber]: true
                    })}>{activeIndex+1}</span>
                    <span>—</span>
                    <span className={classnames({
                      [styles.SingleNumber]: true,
                      [styles.ActiveNumber]:  false
                    })}>{frames.length}</span>
                  </div>
                  <button
                  onClick={this._handleClickNext}
                  className={classnames({
                    [styles.ArrowsBox]: true
                  })}>
                    <ArrowRightIcon style={{
                      width: '15px',
                      hegiht: '15px'
                    }} />
                  </button>
                </div>
              }
              <div className={classnames({
                [styles.ContentBox]: true,
                [styles.Center]: theme === 'light',
                [styles.ContentBoxAnimation]: fadeOut
              })}>
                {frames[activeIndex].props.heading &&
                  <H5 withDetails>
                    {frames[activeIndex].props.heading}
                  </H5>
                }
                {frames[activeIndex].props.description &&
                  <div
                    className={classnames({
                      [styles.ContentArea]: true
                    })}
                  >
                    <Content
                      textAlign={theme === 'dark' ? 'left': 'center'}
                      theme={theme}
                      xmlString={frames[activeIndex].props.description}
                    />
                  </div>
                }
                {CTA &&
                  componentParser([CTA], {
                    gtm: {
                      category: "Feature focus",
                      action: `Clicked button - ${CTA.props.label.toUpperCase()}`
                    }
                  })
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default FeatureFocusBlock



// WEBPACK FOOTER //
// ./src/AtomicContainers/FeatureFocusBlock/FeatureFocusBlock.jsx